import { useRef, useState } from "react";
import { InvoiceTable } from "./Table";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../models/Login";


export const InvoiceTracking = (permissions: IPermissionProps) => {

    const toast = useRef<any>();
    return (
        <>
            <InvoiceTable toast={toast} permissions={permissions} po={{}}/>
            <Toast ref={toast} />
        </>
    );
}